/*格式化数据字典
* 将数据字典转化成下拉列表数据格式*/
import {
    ref,
    computed,
} from "vue";
import queryApi from "@/utils/request";
import { getToken } from '@/utils/auth'

import stores from "@/store/index"
import FileSaver from "file-saver";


const DICT_KEY = "dds";
const DICT_CASCADE_API = "/md/mdCommonType/getCommonItemCasecade";
export const setDict = (dicts)=>{
    sessionStorage.setItem(DICT_KEY, JSON.stringify(dicts));
}
const getDict = ()=>{
    let dict = sessionStorage.getItem(DICT_KEY);
    if(!dict){
        return null;
    }
    return JSON.parse(dict);
}

//table中从数据字典中获取数据
export function formatDicStr(key,filter) {
    if(!key){
        return [];
    }
    const dict = getDict();
    if(!dict){
        return [];
    }
    const codes = dict[key] || [];
    if(!filter || codes.length == 0){
        return codes;
    }
    let cs = [];
    codes.map(c=>{
        if(filter(c)){
            cs.push(c);
        }
    });
    return cs;
}

//从小代码中获取数据字典
export function formatDic(key,filter) {
    let codes = formatDicStr(key,filter);
    for(let i=0;i<codes.length;i++){
        let v = codes[i].value;
        const isNumber = parseFloat(v).toString() != 'NaN';
        if(isNumber){
            if(v.indexOf('.')>=0){
                v = parseFloat(v);
            }else{
                v = parseInt(v);
            }
            codes[i].value = v;
        }        
    }
    return codes;
}

//通过数据字典的key获取value
export function formatDicValue(key,code) {
    let codes = formatDic(key);
    if(!codes){
        return "";
    }

    for(let i=0;i<codes.length;i++){
        if(codes[i].value == code){
            return codes[i].label;
        }
    }
    return "";
}

//通过传入的数据获取名字
export function formatDicData(key, code) {
    return formatDicValue(key,code);
}

// 级联获取数据方法
export function getCascader(cascadeSid){
    if(!cascadeSid){
        return Promise.resolve([]);
    }
    const data = {data:{param_0:{cascadeSid}}};
    
    return queryApi({url:DICT_CASCADE_API,data},'post').then((res)=>{
        let ds = res;
        if(res.data){
            ds = res.data.data_0;
        }
        const items = [];
        
        ds.map(d=>{
            items.push({sid:d.sid,value:d.itemId,label:d.itemName});
        });
        return Promise.resolve(items);
    });
}

export function exportFun(url,code) {
    let param = "&";
    let str = "";
    //遍历code
    if(code){
        for(let k in code){
            param += k+'='+code[k]+'&';
        }
        //去掉最后一个&
        param = param.substring(0,param.length-1);
        str = process.env.VUE_APP_HTTP_ADDR+process.env.VUE_APP_BASE_URL+url+'?Authorization=' +getToken()+param;
    }else{
        str = process.env.VUE_APP_HTTP_ADDR+process.env.VUE_APP_BASE_URL+url+'?Authorization=' +getToken();
    }
    // let str = 'http://10.168.83.18:8080/jgsrp/md/md-export!exportExcel.action?Authorization=' +getToken()+'&qm.exportCode='+code;
    const a = document.createElement('a')
    a.href = str;
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a);
}
//调用接口获取数据字典
export function getDic(options) {
    // {
    //     // path: '/jgsrp/md/md-dd!getDdList.action',
    //     // params: {
    //     //     'qm.ddCode': 'FA_TYPE'
    //     // },
    //     // configName: 'ddName', lable
    //     // configValue: 'ddValue', value
    // }
    if(!options){
       return
    }
    let path = options.path;
    let params = options.params;
    let configName = options.configName;
    let configValue = options.configValue;
    let temp = [];
    //同步获取数据字典
    queryApi({url:path,data:params},options.method,options.isIiot?options.isIiot:false).then((res)=>{
        if(res.items!= undefined){
            //循环res.items
            res.items.forEach((item)=>{
                temp.push({
                    label:item[configName],
                    value:item[configValue]
                })
            })
        }else{
            res.forEach((item)=>{
                temp.push({
                    label:item[configName],
                    value:item[configValue]
                })
            })
        }

        // sessionStorage.setItem('FA_TYPE',JSON.stringify(res.items));
    })
    return temp;
}
//
//关闭顶部小菜单  ocurrentRouter是当前的编辑页面  oListRouter是父级列表页
export function closeCurrentPage(ocurrentRouter,oListRouter){
    let tagsList = computed(() => stores.state.tagsList);

    for (let ln = tagsList.value.length-1; ln >= 0; ln--) {
        if (oListRouter &&tagsList.value[ln]!=undefined&& tagsList.value[ln].name == oListRouter) {
            tagsList.value.splice(ln, 1);
        }
        if (ocurrentRouter && tagsList.value[ln]!=undefined && tagsList.value[ln].name  == ocurrentRouter) {
            tagsList.value.splice(ln, 1);
        }
    }
}

// 级联获取数据方法
// export function getCascader(options){
//     if(!options){
//         return
//     }
//     let path = options.path;
//     let params = options.params;
//     let methods = options.methods?options.methods:'get';
//     let temp = [];
//      //同步获取数据字典
//     queryPostApi({url:path,data:params},methods).then((res)=>{
//         temp = JSON.parse(JSON.stringify(res.items))
//     })
//     return temp;
// }
//前端数值相加
export function addNum(data,field){
   //遍历data
   let num = 0;
   data.forEach((item,index)=>{
        if(item[field]!=undefined&&!isNaN(item[field])){
            if(index == 0){
                num = Number(item[field]);
            }else{
                //计算浮点数相加
                num = accAdd(num,item[field]);
            }
        }
   })
    return num;
}
//计算浮点数相加
export function accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}
//js获取地址栏参数
export  function GetQueryString(name) {
    try {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.hash.split("?")[1].match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    } catch (error) {
        
    }
   


}
//获取uuid
export function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}

/*
* 通用导出
* @param params        {Object} 查询入参
* @param exportCode    {String} 导出配置编码
* @param proxy         {Object} getCurrentInstance()对象
* **/
//，，proxy对象
export function exportFunc(params,exportCode,proxy){
    // const {
    //     proxy
    // } = getCurrentInstance();

    const queryParams = new proxy.$EsayParam();

    if (params) {
        for (let key in params) {
            queryParams.put(key, params[key])
        }
    }
    const esayInfo = new proxy.$EsayInfo();
    esayInfo.add(queryParams)
    proxy.$exportApi(exportCode, esayInfo.data).then(res => {
        const filename = res.filename
        FileSaver.saveAs(
            new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8",
            }),
            filename
        );
    })
}


/**
 * @desc 图片预览、下载地址，文件下载地址 (返回后拼接资源路径)
 * @param fileName        {String} 自定义文件名称（主意后缀，可为空，默认为文件原始名称）
 * @param filePath        {String} 文件存放的相对路径
 * @returns url
 */
export const previewImgUrl = (fileName,filePath) => {
    const token = getToken()
    const url = process.env.VUE_APP_BASE_URL;//process.env.VUE_APP_HTTP_ADDR +
    const className = '/iiot/download/filepath'
    //
    return url + className + '?Authorization=' + token + '&filePath='+ filePath + '&fileName='+ fileName
}

//数组判重
const judgeArrRepeat = (arr,key) => {
    arr.sort();
    for( var i=0;i<arr.length;i++ ){
        if( key ){

            if(arr[key][i]==arr[key][i+1]){//数组有重复
                return true;
            }
        }else{
            if(arr[i]==arr[i+1]){//数组有重复
                return true;
            }
        }
    }
}
//更改组织机构的传入参数
export function setOrgParam(jsonData){
    if(JSON.parse(sessionStorage.getItem('accountItem'))){
        jsonData.param.accountSid = JSON.parse(sessionStorage.getItem('accountItem')).accountId;
    }
   return jsonData;
}

//计划管理=》计划状态收集

export function planStatusChange(keyArr = [],formatName) {
    let arr = [];
    let option = formatDicStr(formatName?formatName:'planStatus');
    for(let i in option){
        if(typeof keyArr === "string"){
            if(option[i].value == keyArr){
                arr.push(option[i])
            }
        }else{
            keyArr.map(e=>{
                if(option[i].value == e){
                    arr.push(option[i])
                }
            })
        }
    }
    return arr;
}

//计划通用submit查询
export function comPlanReq(data,searchReq,statusType,mrType){//typeName =》 statusArray status

    let obj = {};
    if(data.queryData){
        for(let key in data.queryData){
            if(data.queryData[key] && data.queryData[key].length != 0){
                obj[key] = data.queryData[key];
            }
        }
    }
    if(statusType === "status"){
        if( obj[statusType] == null){
            obj[statusType] = searchReq[statusType]
        }
    }else{
        if( obj.statusArray == null){
            obj.statusArray = searchReq.statusArray
        }
    }

    if(mrType){
        if( obj[mrType] == null){
            obj[mrType] = searchReq[mrType]
        }
    }else{
        if(obj.mrType == null){
            obj.mrType = searchReq.mrType
        }
    }
    if (searchReq.workFlag) {
        obj.workFlag = searchReq.workFlag;
    }
    return obj;
}

//table中从数据字典中获取数据
export function formatDicStrWithSid(word) {
    if (!word) return;
    const dds_object = JSON.parse(sessionStorage.dds)[word];
    const temp = []
    if(dds_object){
        for (let k=0;k<dds_object.length;k++) {
            temp.push({
                // label:dds_object[k].itemName,
                // value:dds_object[k].itemId.toString(),
                label:dds_object[k].label,
                value:dds_object[k].value.toString(),
                sid:dds_object[k].sid.toString()
            })
        }
        return temp
    }else{
        return ''
    }
}
//通过传入的数据获取名字
export function formatDicItem(data,key) {
    if(!data) return;
    let temp = {};
    data.forEach((item)=>{
        if(item.value==key){
            temp = item;
            return;
        }
    })
    return temp;
}

// 逻辑库区
export function getInvLogicList1() {
    let invLogicList = [];
    queryApi({url: '/base/base-logic-reservoir-area/findByParams', data: {}}).then((res) => {
        for (let k in res) {
            invLogicList.push({
                label: res[k].invLogicName,
                value: res[k].invLogic
            })
        }
    })
    return invLogicList;
}

// 物理库区
export function getInvPhysic1() {
    let invPhysicList = [];
    queryApi({url: '/base/cg-base-physic-reservoir-area/findByParams', data: {}}).then((res) => {
        for (let k in res) {
            invPhysicList.push({
                label: res[k].invPhysicName,
                value: res[k].invPhysic
            })
        }
    })
    return invPhysicList;
}

// 成本中心
export function getCostCenter() {
    let costCenterList = [];
    queryApi({url: '/base/base-cost-center-info/findByPage', data: {}}).then((res) => {
        const data = res.items;
        for (let k in data) {
            costCenterList.push({
                label: data[k].costCenterName,
                value: data[k].costCenter
            })
        }
    })
    return costCenterList;
}

// 费用类型
export function getExpenseType() {
    let expenseList = [];
    queryApi({url: '/base/cg-base-expense-type/findByParams', data: {}}).then((res) => {
        for (let k in res) {
            expenseList.push({
                label: res[k].expenseName,
                value: res[k].expenseCode
            })
        }
    })
    return expenseList;
}